// "Ask EmmA this" from anywhere on a customer page (15 Oct 2026): the chips on the plan dispatch it, EmmaPageChat listens, opens
// and sends. A module of its own, with no import of `../config`: the CRM renders the customer document in a node test
// (proposal-scope-render.test.ts), where `import.meta.env` is undefined and a config import at module scope throws.
export const EMMA_ASK_EVENT='emma-ask';
export function askEmma(text:string){window.dispatchEvent(new CustomEvent(EMMA_ASK_EVENT,{detail:text}));}
